/* KOVARO — Desktop-Hover fuer Header-Dropdowns (z. B. BRANDS).
   Baut NICHTS neu: nutzt Dawns vorhandenes <details>-Dropdown und oeffnet es
   per Hover. Schliessen mit kurzer Verzoegerung, damit die Maus ins Dropdown
   fahren kann. Inhalt kommt weiter aus dem Shopify-Menue (keine Brands im Code).
   Touch/Mobile: unveraendert -> Dawns Tap-Verhalten im Menue-Drawer. */
(function () {
  if (window.__kvrNav) return; window.__kvrNav = true;
  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  var CLOSE_DELAY = 180;

  function bind() {
    document.querySelectorAll('.header__inline-menu .list-menu--inline > li').forEach(function (li) {
      var det = li.querySelector('details');
      if (!det || li.__kvrNav) return;
      li.__kvrNav = true;
      var summary = det.querySelector('summary');
      var timer = null;

      li.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(timer);
        document.querySelectorAll('.header__inline-menu details[open]').forEach(function (d) {
          if (d !== det) d.open = false;
        });
        if (!det.open) { det.__kvrHover = true; det.open = true; }
      });
      li.addEventListener('mouseleave', function () {
        if (!mq.matches || !det.__kvrHover) return;
        clearTimeout(timer);
        timer = setTimeout(function () { det.open = false; det.__kvrHover = false; }, CLOSE_DELAY);
      });
      /* Per Hover geoeffnet -> Klick auf BRANDS soll es nicht sofort zuklappen.
         Per Tastatur geoeffnete Dropdowns verhalten sich wie bisher. */
      if (summary) summary.addEventListener('click', function (e) {
        if (mq.matches && det.open && det.__kvrHover) e.preventDefault();
      });
    });
  }
  if (document.readyState !== 'loading') bind(); else document.addEventListener('DOMContentLoaded', bind);
})();
